import React from 'react';
import { EmptyListArea } from 'components/EmptyListArea/EmptyListArea';
import { UsersThreeIcon, MagnifyingGlassIcon } from 'components/Icons';

type Props = { onAddPress: () => void; isButtonVisible: boolean; isSearching?: boolean };

const NoPatients: React.FC<Props> = ({ onAddPress, isButtonVisible, isSearching }) => {
  if (isSearching) {
    return (
      <EmptyListArea
        title="No matches found"
        description="No patient records were found for your search. Please review your criteria and try again."
        icon={MagnifyingGlassIcon}
        buttonText="Add patient"
        onAddPress={onAddPress}
        isButtonVisible={isButtonVisible}
      />
    );
  } else {
    return (
      <EmptyListArea
        title="No patients to display yet"
        description="Once you add a patient, their details will appear here, giving you a clear overview of their health journey."
        icon={UsersThreeIcon}
        buttonText="Add patient"
        onAddPress={onAddPress}
        isButtonVisible={isButtonVisible}
      />
    );
  }
};

export default NoPatients;
